import { ReactNode, MouseEvent, memo } from 'react';
import { Span, Subtitle } from './ModalStyle';
import Modal from './Modal.component';
import Button from '../../../../../component/buttton/Button.component';
import GridComponent from '../../../../../component/grid/GridComponent.component';
import { Grid } from '@material-ui/core';

interface Props {
    children?: ReactNode;
    open: boolean;
    handleClick(event: MouseEvent<HTMLElement>): void;
    onClickSubmit(event: MouseEvent<HTMLElement>): void;
    title: string;
    subtitle1?:string;
    subtitle2?:string;
    disabled?: boolean;
}

function ModalConfirm({ open, title, handleClick, onClickSubmit, disabled, subtitle1, subtitle2 }: Props) {

    return (
        <Modal open={open} handleClick={handleClick} >
            <Span>{title}</Span>
            <br />
            <Subtitle>{subtitle1}</Subtitle>
            <br />
            <Subtitle>{subtitle2}</Subtitle>
            <GridComponent margin="10px 0px 10px 0px" spacing={2}>
                <Grid item xs={12}>
                    <Button title='Ok' size='medium' onClick={onClickSubmit} disabled={disabled} fullWidth />
                </Grid>
            </GridComponent>
        </Modal>
    );
}

export default memo(ModalConfirm);
